import { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import EachBox from "./EachBox";
import "./style.css";

import { getCategories } from "Redux/Actions/CategoryActions";
import { Spinner } from "react-bootstrap";

const CategoryItms = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.category.categories);
  const loading = useSelector((state) => state.app.appLoading);

  useEffect(() => {
    dispatch(getCategories());
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <div className="all-category-items  d-flex flex-wrap  justify-content-start container py-4 px-0 ">
        {loading ? (
          <div className=" w-100 text-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          data.map((eachCategory) => {
            return (
              <EachBox
                key={eachCategory.id}
                name={eachCategory.name}
                id={eachCategory.id}
                maxDiscount={eachCategory.max_discount}
              />
            );
          })
        )}
      </div>
    </Fragment>
  );
};

export default CategoryItms;
